import './Collapsible.scss';
import { useState } from 'react';

export type CollapsibleProps = {
	open: boolean;
	title: string;
	link: string;
	fundTicker: string;
	shareClass: string;
	materialTypeAndHeader: {
		header: string;
		materialType: string;
	}[];
	searchRecordMap: Record<string, string>;
	documentId: string;
	blkFundId: string;
	searchResultKey: string;
	iFrameKeyName: string;
	siteContext: string;
	sitePath: string;
};

const Collapsible: React.FC<CollapsibleProps> = ({
	open,
	title,
	link,
	fundTicker,
	shareClass,
	materialTypeAndHeader,
	searchRecordMap,
	documentId,
	blkFundId,
	searchResultKey,
	iFrameKeyName,
	siteContext,
	sitePath,
}) => {
	const [isOpen, setIsOpen] = useState(open);

	const handleFilterOpening = () => {
		setIsOpen((prev) => !prev);
	};

	return (
		<>
			<div
				className={
					'blk-ac col-12 py-2 ' + (isOpen ? 'fundData-active' : 'fundData')
				}
			>
				<span>
					<a
						data-final-url
						href={(link.includes('http') ? '' : '/' + siteContext + '/') + link}
						title={fundTicker}
					>
						{title}
					</a>
				</span>
				<button
					type="button"
					aria-label={isOpen ? 'Open documents list' : 'Close documents list'}
					className="btn span-mobile float-right mx-2"
					onClick={handleFilterOpening}
				>
					{!isOpen ? (
						<div className="center small-icon">
							<i className="fas fa-plus"></i>
						</div>
					) : (
						<div className="center small-icon">
							<i className="fas fa-times"></i>
						</div>
					)}
				</button>
				<div className="fundTickerContainer">
					<span className="fundTicker">{fundTicker}</span>
					<span className="span-mobile">
						{fundTicker +
							(shareClass ? (fundTicker ? ' - ' : '') + shareClass : '')}
					</span>
				</div>
			</div>
			{isOpen ? (
				<div className="mb-3 row">
					{/* // eslint-disable-next-line @typescript-eslint/ban-ts-comment
					// @ts-ignore */}
					{materialTypeAndHeader.map(
						(
							header: { header: string; materialType: string },
							index: number
						) => {
							const documentPath: string = searchRecordMap[header.materialType];
							const displayName: string = documentPath ?? 'NA';
							if (displayName === 'NA') {
								return (
									<div
										className="col-md-4 reg-doc-mobile"
										aria-label="Document Not Available"
										key={index}
									>
										<span className="span-mobile pl-2 pr-2 py-1">NA</span>
										<span className="span-mobile pl-1 py-1">
											{header.header}
										</span>
									</div>
								);
							} else {
								return (
									<div className="col-md-4 reg-doc-mobile" key={index}>
										<a
											data-final-url
											href={`${
												sitePath || '#'
											}?stream=reg&product=${blkFundId || ''}&shareClass=${
												searchResultKey || ''
											}&documentId=${documentId || ''}&${iFrameKeyName || ''}=${
												'/' + siteContext + documentPath || ''
											}`}
											target="_blank"
											rel="noopener noreferrer"
										>
											<i className="fas fa-file-pdf pr-2 py-1"></i>
											<span className="sr-only">{fundTicker + ' '}</span>
											<span className="span-mobile" aria-label={header.header}>
												{header.header}{' '}
											</span>
											<span className="sr-only">(PDF, opens in a new tab)</span>
										</a>
									</div>
								);
							}
						}
					)}
				</div>
			) : (
				<></>
			)}
		</>
	);
};

export default Collapsible;
